export default {
  FETCH_REQUEST: 'PROJECT_LANGUAGE_STATS_FETCH_REQUEST',
  FETCH_FAILURE: 'PROJECT_LANGUAGE_STATS_FETCH_FAILURE',
  FETCH_SUCCESS: 'PROJECT_LANGUAGE_STATS_FETCH_SUCCESS'
}
